var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
document.addEventListener("DOMContentLoaded", () => {
  const votingBooth = document.querySelector("[data-question-status-url]");
  if (!votingBooth) {
    return;
  }
  const statusUrl = votingBooth.dataset.questionStatusUrl;
  if (!statusUrl) {
    return;
  }
  const checkStatus = () => __async(null, null, function* () {
    try {
      const response = yield fetch(statusUrl, {
        method: "GET",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      });
      if (response.ok) {
        const result = yield response.json();
        if (!result.voting_enabled && result.redirect_url) {
          window.location.href = result.redirect_url;
          return;
        }
      }
    } catch (error) {
      console.error("[QuestionStatusChecker] Error:", error);
    }
    setTimeout(checkStatus, 1e3);
  });
  setTimeout(checkStatus, 1e3);
});
